import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n'
import App from './App.tsx'

// Load auth debugger in dev mode
if (import.meta.env.DEV) {
  import('./utils/authDebugger').then(({ default: authDebugger }) => {
    (window as Window & { authDebugger?: typeof authDebugger }).authDebugger = authDebugger;
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
